module.exports = __webpack_public_path__ + "static/media/AMX-Regular.f38038f5.woff2";